import { observer } from "mobx-react";
import { Button } from "../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import IconPlus from "../../../../components/icons/icon-plus/icon-plus";
import AddLanguageWizardModal from "../add-language-wizard-modal/add-language-wizard-modal";
import localesListStore from "../../stores/locales-list-store";

const AddLanguageButton = observer(() => (
    <>
        <div className="portal-and-emails-language-page-main-cta-button">
            <Button 
                variant={BUTTON_VARIANTS.Secondary}
                text="Add Language" 
                leftIcon={IconPlus} 
                onClick={() => localesListStore.setIsAddLanguageWizardOpen(!localesListStore.isAddLanguageWizardOpen)}
            />
        </div>
        {localesListStore.isAddLanguageWizardOpen && <AddLanguageWizardModal />}
    </>
));

export default AddLanguageButton;